var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader",class:{ 'preloader--overlay': _vm.showOverlay }},[_c('div',{staticClass:"preloader__circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }